import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import logoV from './assets/visionary-logo.svg';
import unityLogo from './assets/unity-logo.png';
import footerImg from './assets/blackfield_footer.webp';
import { NEWS } from './news';

export default function NewsPage() {
  const publisherAuthed = sessionStorage.getItem('bf_gate_auth') === '1';
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="article-page">

      <Helmet>
        <title>News – Blackfield | Visionary Games</title>
        <meta name="description" content="Latest dev notes and updates from Blackfield — a dark survival adventure by Visionary Games. Follow development progress, new features, and behind-the-scenes insights." />
        <link rel="canonical" href="https://visionarygames.net/news" />
        <meta property="og:title" content="News – Blackfield | Visionary Games" />
        <meta property="og:description" content="Latest dev notes and updates from Blackfield — a dark survival adventure by Visionary Games." />
        <meta property="og:url" content="https://visionarygames.net/news" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://visionarygames.net/android-chrome-512x512.png" />
        <meta property="og:image:width" content="512" />
        <meta property="og:image:height" content="512" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="News – Blackfield | Visionary Games" />
        <meta name="twitter:description" content="Latest dev notes and updates from Blackfield — a dark survival adventure by Visionary Games." />
        <meta name="twitter:image" content="https://visionarygames.net/android-chrome-512x512.png" />
      </Helmet>

      {/* ── Top Nav ─────────────────────────────────────── */}
      <nav className="top-nav top-nav-solid">
        <div className="top-nav-links">
          <Link to="/" className="top-nav-link top-nav-home">HOME</Link>
          <Link to="/news" className="top-nav-link">NEWS</Link>
          <Link to="/press-kit" className="top-nav-link">PRESS KIT</Link>
          <a href="mailto:yuri@blackfieldgame.com" className="top-nav-link">CONTACT</a>
          <span className="top-nav-link top-nav-disabled">ART BOOK</span>
          <Link to="/publisher" className="top-nav-link top-nav-presentation"><span className="material-symbols-rounded" style={{fontSize:'0.85rem',verticalAlign:'middle'}}>{publisherAuthed ? 'lock_open' : 'lock'}</span> PUBLISHER</Link>
        </div>
      </nav>

      {/* ── Feed ────────────────────────────────────────── */}
      <div className="feed-wrap">
        <h1 className="feed-title">NEWS</h1>
        <div className="feed-list">
          {NEWS.map((item) => (
            <Link key={item.slug} to={`/news/${item.slug}`} className="feed-item">
              <img src={item.img} alt={item.title} className="feed-item-img" />
              <div className="feed-item-text">
                <span className="news-date">{item.date}</span>
                <h2 className="feed-item-title">{item.title}</h2>
                <p className="feed-item-excerpt">{item.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* ── Footer ───────────────────────────────────────── */}
      <div className="site-footer-wrap">
        <img src={footerImg} alt="" className="blackfield-footer-img" />
        <div className="site-footer-overlay">
          <img src={logoV} alt="VISIONARY GAMES" className="footer-logo" />
          <span className="footer-credit">A OSADCHY YURI GAME</span>
          <img src={unityLogo} alt="Made with Unity" className="footer-unity-img" />
        </div>
      </div>

    </div>
  );
}
